import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import type { SxProps, Theme } from '@mui/material/styles';

const checkboxSx: SxProps<Theme> = {
    /** 未选中：图标-按钮 / 主题色-300 */
    color: 'var(--icon-primary-300)',
    '&.Mui-checked': {
        color: (theme) => theme.palette.primary.main,
    },
};

type Props = {
    title?: string;
    checkBoxGroup: { label: string; value: string | number }[];
    value: string[];
    handleChange: (value: string[]) => void;
    row?: boolean;
    disabled?: boolean;
    autoSelected?: (key: string, value: string[]) => string[];
};

type State = Record<string, never>;

/**
 * 多选组（RBP2 迁入，供打印基础设置等页使用）。
 */
export default class CheckBoxGroup extends React.Component<Props, State> {
    /**
     * 勾选/取消单项
     */
    onCheck(value: string, checked: boolean) {
        let newValue = this.props.value;
        if (checked) {
            newValue.push(value);
        } else {
            newValue = newValue.filter((n) => n !== value);
        }
        if (this.props.autoSelected) {
            newValue = this.props.autoSelected(value, newValue);
        }
        this.props.handleChange(newValue);
    }

    render() {
        const { title, value, checkBoxGroup, row, disabled } = this.props;
        return (
            <FormControl component="fieldset">
                {title ? <FormLabel component="legend">{title}</FormLabel> : null}
                <FormGroup row={row ?? true}>
                    {(checkBoxGroup || []).map((item, index) => (
                        <FormControlLabel
                            key={index}
                            label={item.label}
                            control={(
                                <Checkbox
                                    checked={value?.includes(`${item.value}`) || false}
                                    disabled={disabled}
                                    onChange={(e, checked: boolean) => {
                                        this.onCheck(`${item.value}`, checked);
                                    }}
                                    sx={checkboxSx}
                                />
                            )}
                        />
                    ))}
                </FormGroup>
            </FormControl>
        );
    }
}
